<template>
  <div class="pop-payment-wrap">
    <div class="pop-header">
      <span class="pop-title">멤버십 쿠폰</span>
      <button class="btn-pop-close" @click="$.emit('close')">
        닫기<span class="overlay"></span>
      </button>
    </div>
    <div class="pop-body">
      <div class="fieldset">
        <span class="h2">회원정보</span>
        <div class="ip-row">
          <label for="memCloud">클라우드 멤버십</label>
          <!-- 기본 포커스 스타일 제거, 포커스 효과: 아래 요소에 on 클래스 추가 -->
          <input
            type="text"
            class="ip-comm center on"
            id="memCloud"
            placeholder="카드번호, 회원번호, 핸드폰번호를 입력하세요"
          />
        </div>
        <div class="ip-row col04">
          <label for="memName">회원명</label>
          <input type="text" class="ip-comm center" id="memName" value="0" />
          <label for="memNum">회원번호</label>
          <input type="text" class="ip-comm center" id="memNum" value="0" />
        </div>
        <div class="ip-row col04">
          <label for="avaPoint">가용포인트</label>
          <input type="text" class="ip-comm center" id="avaPoint" value="0" />
          <label for="accPoint">누적포인트</label>
          <input type="text" class="ip-comm center" id="accPoint" value="0" />
        </div>
      </div>
      <div class="flex">
        <table class="tb-lst-payment tb-coupon">
          <thead>
            <tr>
              <td>쿠폰명</td>
              <td>구분</td>
              <td>율/금액</td>
              <td>최대할인금액</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(coupon,index) in couponList" :key="index"
              :class="{ 'on': activeCoupon == index }"
              @click="activeCoupon = index"
            >
              <td>{{coupon.couponName}}</td>
              <td>{{coupon.couponType == 1 ? "&#8361;할인" : '%할인'}} </td>
              <td>{{coupon.couponType == 2 ? `${coupon.couponDiscount}%` : coupon.couponDiscount}}</td>
              <td>{{coupon.couponMaxDiscount}}</td>
            </tr>
            
          </tbody>
        </table>
        <div class="tb-side-btn">
          <button type="button" class="btn-side-up">
            위로<span class="overlay"></span>
          </button>
          <button type="button" class="btn-side-down">
            아래로<span class="overlay"></span>
          </button>
        </div>
      </div>
    </div>
    <!-- 버튼이 두개인 경우에 아래 요소에 클래스명 btn02 추가 -->
    <div class="pop-btn-area btn02">
      <!-- [팝업버튼 크기] .btn-pop: 100%, .btn-pop.btn-half: 50%, .btn-pop.btn-third: 33.33%, .btn-pop.btn-fourth: 25% -->
      <button type="button" class="btn-pop btn-fourth btn-main">
        멀티패드<span class="overlay"></span>
      </button>
      <button type="button" class="btn-pop btn-half btn-submit" @click="payInCoupon">
        쿠폰사용<span class="overlay"></span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "membershipCoupon",
  props: {
    totalUprc: Number,
    totalDiscount: Number,
    receivedUprc: Number,
  },
  data() {
    return {
      useYn: false,
      couponList : this.$store.getters.getCouponList,
      totalCash: this.totalUprc-this.totalDiscount,
      activeCoupon : 0,
    };
  },
  methods: {
    loadingPromise(text){
      this.$.emit('openLoading', text);
      return new Promise((resolve) => {
        setTimeout(()=>{
          this.$.emit('closeLoading');
          resolve(1);
        },1000)
      })
    },
    async payInCoupon(){
      let coupon = this.couponList[this.activeCoupon];
      let finalDiscount = coupon.couponType == 1 ? coupon.couponDiscount : this.totalCash/100*coupon.couponDiscount;
      
      if(finalDiscount > coupon.couponMaxDiscount) finalDiscount = coupon.couponMaxDiscount;

      if(finalDiscount > this.totalCash) finalDiscount = this.totalCash;

      await this.loadingPromise("쿠폰을 조회 중 입니다.");
      
      this.$.emit('setReceivedUprc',finalDiscount);
      this.$.emit('close');
    },
  },
  watch: {},
  computed: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  unmounted() {},
  components: {},
};
</script>

<style src="@/assets/css/style.css" scoped></style>
<style scoped></style>


